var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C7.2125 0 0.5 6.7125 0.5 15C0.5 23.2875 7.2125 30 15.5 30C23.7875 30 30.5 23.2875 30.5 15C30.5 6.7125 23.7875 0 15.5 0ZM17 25.5H14V22.5H17V25.5ZM20.0975 13.8825L18.755 15.2625C17.675 16.3425 17 17.25 17 19.5H14V18.75C14 17.0925 14.675 15.5925 15.755 14.505L17.6225 12.615C18.1625 12.075 18.5 11.325 18.5 10.5C18.5 8.8425 17.1575 7.5 15.5 7.5C13.8425 7.5 12.5 8.8425 12.5 10.5H9.5C9.5 7.185 12.185 4.5 15.5 4.5C18.815 4.5 21.5 7.185 21.5 10.5C21.5 11.82 20.9675 13.0125 20.0975 13.8825Z",
    fill: "#393185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.6c9e1b7252be24f3d3ed457ed4a27dc5.svg";
export { ForwardRef as ReactComponent };